export default __webpack_public_path__ + "static/media/modules_dark.d165e1f4.png";